export default {
  LINK: {
    COMPANY: '運営会社',
    TERMS_OF_SERVICE: '利用規約',
    PRIVACY_POLICY: 'プライバシーポリシー',
  },
};
